export const proposalPayloadCheck = (payload) => {
  //check the values on administrationControl members
  if (payload.administrationControl && payload.administrationControl.members)
    payload.administrationControl.members = payload.administrationControl.members?.filter(e => !!e?.idNumber);
  
  //check the values on inspectionControl members
  if (payload.inspectionControl && payload.inspectionControl.members)
    payload.inspectionControl.members = payload.inspectionControl.members?.filter(e => !!e?.idNumber);
  
  //check the values on the partners members
  if (payload.partners && payload.partners)
    payload.partners = payload.partners.map(e => {
      return {
        ...e,
        phone: e?.phone?.filter((p) => p && p?.phone)
      };
    });
  return payload;
};
